/* eslint-disable no-unused-vars */
function sortAlphabetically(input, base, ascending)
{
    const deepCopy = input.slice()

    if (ascending)
    {
        deepCopy.sort( (a, b) => {
            const itemA = a[base].toLowerCase();
            const itemB = b[base].toLowerCase();

            if (itemA < itemB)
            {
                return -1;
            }
            if (itemA > itemB)
            {
                return 1;
            }
            return 0;
        });
    }
    else 
    {
        deepCopy.sort( (b, a) => {
            const itemA = a[base].toLowerCase();
            const itemB = b[base].toLowerCase();

            if (itemA < itemB)
            {
                return -1;
            }
            if (itemA > itemB)
            {
                return 1;
            }
            return 0;
        });
    }

    return deepCopy;
}

function sortNumerically(input, base, ascending)
{

    const deepCopy = input.slice();

    if (ascending)
    {
        deepCopy.sort( (a, b) => a[base] - b[base]);
    }
    else 
    {
        deepCopy.sort( (b, a) => a[base] - b[base]);
    }

    return deepCopy;
}

function sortDates(input, base, ascending) {
    const deepCopy = input.slice();
    if (ascending) 
    {
        deepCopy.sort((a, b) => {
            const dateA = new Date(parseDate(a[base]).year, parseDate(a[base]).month, parseDate(a[base]).day);
            const dateB = new Date(parseDate(b[base]).year, parseDate(b[base]).month, parseDate(b[base]).day); 
            return dateA - dateB;
        });
    } else {
        deepCopy.sort((b, a) => {
            const dateA = new Date(parseDate(a[base]).year, parseDate(a[base]).month, parseDate(a[base]).day);
            const dateB = new Date(parseDate(b[base]).year, parseDate(b[base]).month, parseDate(b[base]).day);
            return dateA - dateB;
        });
    }

    return deepCopy;
}

function parseDate(_date) {
    const date = _date.split('/');

    const year = date[0];
    const month = date[1];
    const day = date[2];

    return { year, month, day };
}
function parseDateWithTime(_date) {
    const {date, time} = _date.split(" - ");

    const {month, day, year } = date.split("/");
    const {hour, minute} = time.split(":");

    return {month, day, year, hour, minute};
}

export { sortAlphabetically, sortNumerically, sortDates };